import React, { memo } from "react";
import { useMediaQuery } from 'react-responsive'

export const SeikenClinicInfo = memo((props) => {
  const isMobileScreen = useMediaQuery({ query: '(max-width: 760px)'});

  return (
    <>
      <div className="card">
        <div className="card-header"><b className="h4">ご注意事項</b></div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm">
              <ul>
                <li>人間ドックのみ受診可能です。</li>
                <li>ご予約時に予約内容が確定されます。</li>
                <li>心臓セットは今年度は運用中止になっております。</li>
                <li className="text-danger">鎮静剤(胃部内視鏡)（¥3,300）は火曜午後の経口胃カメラのみ申込可能です。</li>
                <li>50歳以上の方には、オプション「腫瘍マーカー」がおすすめです。</li>
                <li>表示日以前のご予約は「健診予約窓口（03-3639-5501）」に直接ご連絡願います。</li>
              </ul>
            </div>
            <div className="col-sm">
              <div className="card bg-light">
                <div className="card-header">病院情報</div>
                <div className="card-body">
                  朝日生命成人病研究所附属医院<br />
                  住所：〒103-0002 東京都中央区日本橋馬喰町2-2-6 朝日生命須長ビル<br />
                  電話番号：03-3639-5501
                  <table className="table table-bordered table-condensed mb-3 mt-2">
                    <thead>
                      <tr className="bg-light text-center">
                        <th>月</th>
                        <th>火</th>
                        <th>水</th>
                        <th>木</th>
                        <th>金</th>
                        <th>土</th>
                        <th>日</th>
                        <th>祝</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="text-center">
                        <td>○</td>
                        <td>○</td>
                        <td>ー</td>
                        <td>○</td>
                        <td>ー</td>
                        <td>ー</td>
                        <td>ー</td>
                        <td>ー</td>
                      </tr>
                    </tbody>
                  </table>
                  <p className="mt-3">
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
});